module.exports = "<div class=panel> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=authsettings translate>Auth Settings</a> </li> </ol> </div> <div class=panel-body> <a class=\"btn btn-primary\" ui-sref=authsettings.users>Users</a> <a class=\"btn btn-primary\" ui-sref=authsettings.server>Identity Server</a> </div> </div> <div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/authsettings/components/authsettings.html
// module id = 384
// module chunks = 0